/**
 * Core – Dashboard / Home
 */

import home from "./home.js";

export default {
  home,
  dash: {
    month: "Month",
    annually: "annually",
    yVAT: "Yearly VAT",
    qVAT: "Quarterly VAT",
    mVAT: "Monthly VAT",
    yEPR: "Yearly",
    qEPR: "Quarterly",
    mEPR: "Monthly",
    ySalexTax: "Yearly Sales tax",
    qSalesTax: "Quarterly Sales tax",
    mSalesTax: "Monthly Sales tax",
    fillVR: "Fill Return",
  },
};
